import {useMemo} from "react";
import {useTranslation} from "react-i18next";

const useCountryOptions = countries => {
  const {i18n} = useTranslation();
  const countriesOptions = useMemo(() => {
    return (
      countries?.map(({countryId, shortName, shortNameEng}) => ({
        title: i18n.language === "en" ? shortNameEng || shortName : shortName || shortNameEng,
        value: countryId,
      })) || []
    );
  }, [countries, i18n.language]);

  return {countriesOptions};
};

export default useCountryOptions;
